import { autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { TableHeader } from 'components/table/table-content';
import { FilterManager } from 'lib/tables/FilterManager';
import { Filters, filterTypes } from 'elements/Filter';
import { ErpSystemService } from 'services/erp-system-service';
import { ErpSystem } from 'models/ErpSystem';
import { ProductService } from 'services/product-service';
import { ErrorService } from 'services/error-service';
import { PubSub } from 'lib/event/PubSub';
import { EventAggregator } from 'aurelia-event-aggregator';

type ProductsListType = {
  ArticleNo: string;
  CostPrice: number;
  Inventory: number;
  MinBreakingStrength: number;
  Name: string;
  WeightPerUnit: number;
  ErpSystemName: number;
};

@autoinject
export class ProductsList {
  protected productListData: ProductsListType[] = [];

  protected erpSystems: ErpSystem[] = [];

  protected tableHeaders: TableHeader<ProductsListType>[] = [
    { key: 'Name', label: 'general.name', sortable: true },
    { key: 'ArticleNo', label: 'general.articleno', sortable: true },
    { key: 'CostPrice', label: 'general.costprice', sortable: true },
    { key: 'Inventory', label: 'general.inventory', sortable: true },
    { key: 'MinBreakingStrength', label: 'service.minBreakingStrength', sortable: true },
    { key: 'WeightPerUnit', label: 'general.weightUnit', sortable: true },
    { key: 'ErpSystemName', label: 'general.erpSystem', sortable: true },
  ];

  constructor(
    private t: I18N,
    protected fm: FilterManager,
    private eventAggregator: EventAggregator,
    protected erpSystemService: ErpSystemService,
    protected productService: ProductService,
    private errorService: ErrorService,
    private pubsub: PubSub
  ) {
    pubsub.sub('filter-manager:filter-changed', () => {
      this.getProducts();
    });
  }

  protected async attached() {
    this.eventAggregator.subscribe('productsListReset', () => {
      this.getProducts();
    });

    await this.load();

    this.fm.init({
      context: 'admin-products-list',
      storageKey: 'admin-products-list',
      filters: {
        erpIds: {
          name: 'erpIds',
          label: this.t.tr('general.erpSystem'),
          type: filterTypes.CHECKBOX,
          options: this.erpSystems,
          query: 'erpIds',
        },
      } satisfies Filters,
      defaultFilters: {
        erpIds: true,
      },
    });
  }

  private async load() {
    const erpSystems = await this.erpSystemService.getAll();
    const newList = erpSystems.map((e) => {
      const newItem = { ...e, Name: e.Title };
      delete newItem.Title;
      return newItem;
    });

    this.erpSystems = newList;
  }

  protected async getProducts() {
    try {
      const response = await this.productService.getProductsList(this.fm.queryFilter);
      if (!response) return;
      this.fm.paginationTotalRecords = +response.headers.get('x-total-count') || 0;

      this.productListData = response.data;
    } catch (error) {
      this.errorService.handleError(error);
    }
  }
}
